import Swiper from "swiper/bundle";

class Slider {
  constructor() {
    this.projectSliderContainer = document.querySelectorAll(".slider-projects");
    this.filterSliderContainer = document.querySelectorAll(".filter-swiper");
    this.SliderFilterSectors = document.querySelectorAll(
      ".filter-sectors-swiper"
    );
    this.cardsSliderContainer = document.querySelectorAll(".slider-cards");

    if (this.projectSliderContainer.length > 0) {
      this.initProjectSlider();
    }

    if (this.filterSliderContainer.length > 0) {
      this.initFilterSlider();
    }

    if (this.SliderFilterSectors.length > 0) {
      this.initSliderFilterSectors();
    }

    if (this.cardsSliderContainer.length > 0) {
      this.initCardsSlider();
    }
  }
  // Slider projects - non in uso
  initProjectSlider() {
    this.projectSliderContainer.forEach((slider) => {
      new Swiper(slider, {
        loop: false,
        spaceBetween: 20,
        slidesPerView: 1.2,
        keyboard: {
          enabled: true,
        },
        pagination: {
          el: slider.querySelector(".swiper-pagination"),
          clickable: true,
          dynamicBullets: false,
        },
        navigation: {
          nextEl: slider.querySelector(".arrow-next"),
          prevEl: slider.querySelector(".arrow-prev"),
        },
        breakpoints: {
          576: {
            slidesPerView: 2.2,
          },
          768: {
            slidesPerView: 3.2,
          },
        },
      });
    });
  }

  // Slider Filter Solutions Projects

  initFilterSlider() {
    this.filterSliderContainer.forEach((slider) => {
      new Swiper(slider, {
        slidesPerView: 2.2,
        spaceBetween: 10,
        freeMode: true,
        breakpoints: {
          700: {
            slidesPerView: 4.5,
          },
          1200: {
            slidesPerView: 8.5,
            freeMode: false,
          },
          1400: {
            slidesPerView: 9,
            freeMode: false,
          },
        },
      });
    });
  }

  // Slider Filter Sectors Projects
  initSliderFilterSectors() {
    this.SliderFilterSectors.forEach((slider) => {
      new Swiper(slider, {
        slidesPerView: 2.2,
        spaceBetween: 10,
        grabCursor: true,
        mousewheel: {
          forceToAxis: true,
        },
        freeMode: {
          enabled: true,
          sticky: true,
        },

        breakpoints: {
          700: {
            slidesPerView: 3.5,
          },
          1200: {
            slidesPerView: 4.5,
          },
          1400: {
            slidesPerView: 5.2,
          },
        },
      });
    });
  }

  // Slider Card Block (ACF)
  initCardsSlider() {
    this.cardsSliderContainer.forEach((slider) => {
      new Swiper(slider, {
        spaceBetween: 15,
        slidesPerView: 1, // full-width card, un solo slide visibile a ogni breakpoint
        keyboard: {
          enabled: true,
        },
        pagination: {
          el: slider.querySelector(".swiper-pagination"),
          clickable: true,
          dynamicBullets: false,
          renderBullet: function (index, className) {
            return (
              '<button type="button" class="' +
              className +
              '">' +
              (index + 1) +
              "</button>"
            );
          },
        },
        navigation: {
          nextEl: slider.querySelector(".arrow-next"),
          prevEl: slider.querySelector(".arrow-prev"),
        },
      });
    });
  }
}

export default Slider;